<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          amzReplenishmentCode: chooseTemplateOptions.amzReplenishmentCode,
          userCode: chooseTemplateOptions.userCode,
        },
      }"
      @export-success="() => {}"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import dayjs from '@/libs/util.date'
import chooseTemplate from '@/views/ecom/components/choose-template'
import { mapState } from 'vuex'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        amzReplenishmentCode: '',
        userCode: '',
        templateGroup: '',
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          const data = res.body.data
          this.tableData = (data || []).map((item) => {
            const { endDate: date } = item
            if (!date) return item
            const currDate = new Date(dayjs().format('YYYY-MM-DD')).getTime()
            const endDate = new Date(dayjs(date).format('YYYY-MM-DD')).getTime()
            const endDays = (currDate - endDate) / (1000 * 60 * 60 * 24)
            return { ...item, endDays }
          })
          this.page.pageTotal = res.body.count
          this.page.pageSize = res.body.pageSize
          this.page.curPage = res.body.curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile({ amzReplenishmentCode }, { templateGroup }) {
      if (!!this.info || this.info !== {}) {
        const { userCode } = this.info
        this.chooseTemplateOptions = {
          visible: true,
          amzReplenishmentCode,
          userCode,
          templateGroup,
        }
      }
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-replenishment-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
